import type { StorageAdapter } from "../types/storage.js";

export class LockManager {
  constructor(
    private readonly storage: StorageAdapter,
    private readonly defaultTtlMs: number
  ) {}

  acquire(lockKey: string, ttlMs = this.defaultTtlMs): Promise<boolean> {
    return this.storage.acquireLock(lockKey, ttlMs);
  }

  release(lockKey: string): Promise<void> {
    return this.storage.releaseLock(lockKey);
  }
}
